import React, { FC } from 'react';
import { Text, Anchor } from '@cubeyou-team/hx-react-components';
import { interpolate } from '@discover-frontend/utils';

import { PRIVACY_URL, SERVICE_DESCRIPTIONS_URL } from 'src/constants/config';
import translations from 'src/lang';

const { FOOTER } = translations['en-US'];

const FOOTER_LINK_CLASS = 'hx-link-on-dark';

const DefaultFooterContent = () => (
  <>
    <Text variant="light" size="small" as="span">
      {interpolate(FOOTER.RIGHT_RESERVED, { year: new Date().getFullYear() })}
    </Text>
    <Anchor
      href={SERVICE_DESCRIPTIONS_URL}
      target="_blank"
      className={FOOTER_LINK_CLASS}
    >
      {FOOTER.SERVICE_DESCRIPTIONS}
    </Anchor>
    <Anchor href={PRIVACY_URL} target="_blank" className={FOOTER_LINK_CLASS}>
      {FOOTER.PRIVACY}
    </Anchor>
  </>
);

export const FooterContainer: FC = () => (
  <div className="w-full bottom-0 fixed z-50 bg-hx-primary">
    <div className="flex items-center gap-12 pl-12 h-14">
      <DefaultFooterContent />
    </div>
  </div>
);
